import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import moment from "moment-timezone";
import { BsModalRef } from 'ngx-bootstrap/modal';
import { JoSchedularService } from 'src/app/_services/jo-schedular.service';
import { ErrorUtil } from 'src/app/_utilities/error';

@Component({
  selector: 'app-re-schedule',
  templateUrl: './re-schedule.component.html',
  styleUrl: './re-schedule.component.scss',
  standalone: false
})
export class ReScheduleComponent implements OnInit {
  data: any
  installationTime!: any;
  tomorrow!: Date;
 
  constructor(
    public modalRef: BsModalRef,
    private joSchedularService: JoSchedularService,
    private errorUtil: ErrorUtil
  ) { }

  ngOnInit(): void {
  console.log(this.data);
  if (this.data.installationTime) {
    const installationTime = this.data.installationTime;

    // ✅ FIX: p-calendar needs a native Date, not a moment object.
    // moment.tz() returns a moment — call .toDate() to convert it.
    this.installationTime = moment.tz(installationTime, this.data.timezone) // ✅ .toDate() added

    this.data.installationTime = moment.tz(installationTime, this.data.timezone).toDate(); // ✅ .toDate() added
  }
  this.getFutureDate();
}
/****************************************** Get Future Date *****************************/
getFutureDate() {
    if (this.data?.installationTime) {
    // ✅ Block everything up to and including installationTime's date.
    // minDate = next day at 00:00:00 so the user can only pick future dates.
    const next = new Date(this.data.installationTime);
    next.setDate(next.getDate());
    next.setHours(0, 0, 0, 0);
    this.tomorrow =  next;
  }else{
    // ✅ Fallback: no installationTime — block only past dates (tomorrow onwards)
    const t = new Date();
    t.setDate(t.getDate() + 1);
    t.setHours(0, 0, 0, 0);
    this.tomorrow = t;
  }

}
isSubmitDisabled(): boolean {
  return !this.data.installationTime;
}
public onOrderDate(newDate: Date) {
    this.data.installationDate = newDate;
  
  this.data.estimatedCompletionDuration = 120; // Default to 2 hours (120 minutes)

    if (this.data.installationDate) {
      const startDate = new Date(this.data.installationDate);
      const endDate = new Date(startDate.getTime() + 120 * 60000);
      this.data.endDateTime = endDate;
    }
  }
/****************************************** Update Next Maintenance Date *****************************/
updateOrderDateTime() {
  // ✅ data.installationTime is now a native Date (set by p-calendar via ngModel)
  const payload = {
    jobOrderId: this.data.id,
    user : this.data.orderOwner ? this.data.orderOwner : null,
    installationTime: moment.tz(
      this.data.installationTime,  // ✅ use the updated value from p-calendar
      this.data.timezone
    ).format(),
    endDateTime: moment.tz(
      this.data.endDateTime,
      this.data.timezone
    ).format(),
    estimatedDuration: this.data.estimatedCompletionDuration
  };
  if(payload.user == null){
    delete payload.user;
  }

  this.joSchedularService.jobOrderReSchedule(payload).subscribe(
    (res: any) => {
      console.log('Next maintenance date updated successfully:', res);
      this.errorUtil.setErrorMessage(res.status, res.body?.title, null, 'success',3000);
      this.modalRef.hide();

    },
    (error: any) => {
      console.log('Error Response:', error?.error);
      this.errorUtil.setErrorMessage(error.status,null, error.error?.title, 'error',3000);
      console.error('Error updating next maintenance date:', error);
    }
  );
}
}
